'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsTransitionGroup = require('react-addons-transition-group');

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _EventManager = require('./util/EventManager');

var _EventManager2 = _interopRequireDefault(_EventManager);

var _Toast = require('./Toast');

var _Toast2 = _interopRequireDefault(_Toast);

var _DefaultCloseButton = require('./DefaultCloseButton');

var _DefaultCloseButton2 = _interopRequireDefault(_DefaultCloseButton);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  position: _propTypes2.default.oneOf(Object.values(_config2.default.POSITION)),
  autoClose: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
  closeButton: _propTypes2.default.element,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};

var defaultProps = {
  position: _config2.default.POSITION.TOP_RIGHT,
  autoClose: 5000,
  closeButton: null
};

var ToastContainer = function (_Component) {
  _inherits(ToastContainer, _Component);

  function ToastContainer(props) {
    _classCallCheck(this, ToastContainer);

    var _this = _possibleConstructorReturn(this, (ToastContainer.__proto__ || Object.getPrototypeOf(ToastContainer)).call(this, props));

    _this.state = {
      toast: []
    };
    _this.toastId = 0;
    _this.collection = {};
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    return _this;
  }

  _createClass(ToastContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _EventManager2.default.on(_config2.default.ACTION.SHOW, function (content, options) {
        return _this2.show(content, options);
      }).on(_config2.default.ACTION.CLEAR, function () {
        return _this2.clear();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _EventManager2.default.off(_config2.default.ACTION.SHOW);
      _EventManager2.default.off(_config2.default.ACTION.CLEAR);
    }
  }, {
    key: 'setAutoClose',
    value: function setAutoClose(toastId, delay) {
      var _this3 = this;

      return setTimeout(function () {
        return _this3.removeToast(toastId);
      }, delay);
    }
  }, {
    key: 'isFunction',
    value: function isFunction(object) {
      return !!(object && object.constructor && object.call && object.apply);
    }
  }, {
    key: 'shouldAutoClose',
    value: function shouldAutoClose(autoCloseOpt) {
      return !!(this.props.autoClose !== false && autoCloseOpt !== false || this.props.autoClose === false && autoCloseOpt !== false && autoCloseOpt !== null);
    }
  }, {
    key: 'removeToast',
    value: function removeToast(id) {
      this.setState({ toast: this.state.toast.filter(function (v) {
          return v !== parseInt(id, 10);
        }) });
    }
  }, {
    key: 'withClose',
    value: function withClose(component, props) {
      return (0, _react.cloneElement)(component, _extends({}, props, component.props));
    }
  }, {
    key: 'validateCloseButton',
    value: function validateCloseButton(closeButton) {
      if (!(0, _react.isValidElement)(closeButton)) {
        throw new Error('CloseButton must be a valid react element instead of ' + (typeof closeButton === 'undefined' ? 'undefined' : _typeof(closeButton)));
      }
    }
  }, {
    key: 'makeCloseButton',
    value: function makeCloseButton(optCloseButton, toastId) {
      var _this4 = this;

      var closeButton = _react2.default.createElement(_DefaultCloseButton2.default, null);

      if (optCloseButton === null && this.props.closeButton !== null) {
        closeButton = this.props.closeButton;
      } else if (optCloseButton !== null) {
        this.validateCloseButton(optCloseButton);
        closeButton = optCloseButton;
      }

      return this.withClose(closeButton, { closeToast: function closeToast() {
          return _this4.removeToast(toastId);
        } });
    }
  }, {
    key: 'show',
    value: function show(content, options) {
      content = typeof content === 'string' ? _react2.default.createElement(
        'div',
        null,
        content
      ) : content;

      if ((0, _react.isValidElement)(content)) {
        var toastId = ++this.toastId;
        var autoCloseOpt = options.autoClose;
        var fn = function fn() {};
        var toastOptions = {
          id: toastId,
          type: options.type,
          onOpen: this.isFunction(options.onOpen) ? options.onOpen : fn,
          onClose: this.isFunction(options.onClose) ? options.onClose : fn,
          closeButton: this.makeCloseButton(options.closeButton, toastId)
        };

        if (this.shouldAutoClose(autoCloseOpt)) {
          var delay = autoCloseOpt !== null ? parseInt(autoCloseOpt, 10) : this.props.autoClose;

          toastOptions.autoCloseId = this.setAutoClose(toastId, delay);
          toastOptions.autoCloseDelay = delay;
          toastOptions.handleMouseEnter = this.handleMouseEnter;
          toastOptions.handleMouseLeave = this.handleMouseLeave;
        }

        this.collection = Object.assign({}, this.collection, _defineProperty({}, toastId, this.makeToast(content, toastOptions)));

        this.setState({
          toast: [].concat(_toConsumableArray(this.state.toast), [toastId])
        });
      }
    }
  }, {
    key: 'makeToast',
    value: function makeToast(content, options) {
      return _react2.default.createElement(
        _Toast2.default,
        _extends({}, options, {
          position: this.props.position,
          key: 'toast-' + options.id + ' '
        }),
        content
      );
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.collection = {};
      this.setState({ toast: [] });
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(e) {
      clearTimeout(e.currentTarget.dataset.autoCloseId);
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave(e) {
      var _e$currentTarget$data = e.currentTarget.dataset,
          toastId = _e$currentTarget$data.toastId,
          autoCloseDelay = _e$currentTarget$data.autoCloseDelay;

      if (this.state.toast.length > 0 && typeof this.collection[toastId] !== 'undefined') {
        this.collection[toastId] = (0, _react.cloneElement)(this.collection[toastId], {
          autoCloseId: this.setAutoClose(toastId, autoCloseDelay)
        });

        this.forceUpdate();
      }
    }
  }, {
    key: 'isObjectEmpty',
    value: function isObjectEmpty() {
      return this.state.toast.length === 0;
    }
  }, {
    key: 'renderProps',
    value: function renderProps() {
      var props = {
        className: 'toastify toastify--' + this.props.position
      };

      if (this.props.className) {
        props.className = props.className + ' ' + this.props.className;
      }

      if (this.props.style) {
        props.style = this.props.style;
      }

      return props;
    }
  }, {
    key: 'renderToast',
    value: function renderToast() {
      var _this5 = this;

      return Object.keys(this.collection).map(function (idx) {
        if (_this5.state.toast.includes(parseInt(idx, 10))) {
          return _this5.collection[idx];
        } else {
          delete _this5.collection[idx];
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        this.renderProps(),
        _react2.default.createElement(
          _reactAddonsTransitionGroup2.default,
          null,
          this.isObjectEmpty() ? null : this.renderToast()
        )
      );
    }
  }]);

  return ToastContainer;
}(_react.Component);

ToastContainer.defaultProps = defaultProps;
ToastContainer.propTypes = propTypes;

exports.default = ToastContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toastify/lib/ToastContainer.js
// module id = 554
// module chunks = 0